export const CourseListConstants = {
    GETALL_REQUEST: 'COURSE_SETTING_REQUEST',
    GETALL_SUCCESS: 'COURSE_SETTING_SUCCESS',
    GETALL_FAILURE: 'COURSE_SETTING_FAILURE',
};


//CourseListConstants


// WEBPACK FOOTER //
// ./src/_constants/course-settings.constants.js